export default {
  viewBox: "0 0 24 24",
  html: "<path d=\"m22.09 11.58-9-9A2 2 0 0 0 11.68 2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9a2 2 0 0 0 1.41.58 2 2 0 0 0 1.41-.59l7-7a2 2 0 0 0 .59-1.41 2 2 0 0 0-.59-1.42M13.68 20l-9-9V4h7l9 9zM7.18 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3\"/>"
};